import { Container, Box, Typography, Stack } from "@mui/material";
import ButtonsMainGoTo from "../../../components/Button/ButtonMainGoTo";
import { useAuth } from "../../../provider";
import { useTranslation } from "../../../language";
import * as api from "../../../Auth/auth";

export default function OnboardingAddonCancel() {
  const { t } = useTranslation();
  const { handleLogout } = useAuth();

  const handleLogoutApi = async () => {
    const response = await api.logout();
    await handleLogout(response);
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <Box
        sx={{
          p: 4,
          textAlign: "center",
          borderRadius: 3,
          boxShadow: 3,
          backgroundColor: "background.paper",
        }}
      >
        <Typography variant="h4" color="error" gutterBottom>
          ❌ {t("onb_snc_title")}
        </Typography>
        <Typography variant="body1" color="text.secondary" mb={4}>
          {t("onb_snc_body")}
        </Typography>

        <Stack direction="row" spacing={2} justifyContent="center">
          <ButtonsMainGoTo name={t("onb_snc_retry")} to="/AddonSelection" />
          <ButtonsMainGoTo name={t("onb_snc_logout")} to="/" onClick={handleLogoutApi} />
        </Stack>
      </Box>
    </Container>
  );
}
